<template>
  <div id="app">
    <!-- 导航栏 -->
    <nav
      class="fixed top-0 w-full z-50 bg-white/80 dark:bg-[#1e293b]/80 backdrop-blur-md shadow-sm"
    >
      <div class="container flex justify-between items-center py-4">
        <h1 class="text-xl font-bold">倪国晓的简历</h1>
        <div class="flex items-center gap-4">
          <button
            @click="toggleDarkMode"
            class="p-2 rounded-full hover:bg-gray-100 dark:hover:bg-gray-800"
          >
            <svg
              v-if="!isDark"
              xmlns="http://www.w3.org/2000/svg"
              class="h-6 w-6"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M20.354 15.354A9 9 0 018.646 3.646 9.003 9.003 0 0012 21a9.003 9.003 0 008.354-5.646z"
              />
            </svg>
            <svg
              v-else
              xmlns="http://www.w3.org/2000/svg"
              class="h-6 w-6"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M12 3v1m0 16v1m9-9h-1M4 12H3m15.364 6.364l-.707-.707M6.343 6.343l-.707-.707m12.728 0l-.707.707M6.343 17.657l-.707.707M16 12a4 4 0 11-8 0 4 4 0 018 0z"
              />
            </svg>
          </button>
          <a href="#home" class="hover:text-[#3b82f6]">首页</a>
          <a href="#skills" class="hover:text-[#3b82f6]">技能</a>
          <a href="#experience" class="hover:text-[#3b82f6]">经历</a>
          <!-- <a href="#projects" class="hover:text-[#3b82f6]">项目</a> -->
        </div>
      </div>
    </nav>

    <!-- 首页 Hero 区域 -->
    <section id="home" class="section pt-32">
      <div class="container flex flex-col md:flex-row items-center gap-8">
        <div class="md:w-1/2 fade-in mt-8">
          <h1 class="text-4xl md:text-5xl font-bold mb-4">
            你好，我是 <span>倪国晓</span>
          </h1>
          <p class="text-xl md:text-2xl mb-6">前端开发工程师</p>
          <!-- 个人资料卡片：毛玻璃风格 + 滚动渐显 + 图标 -->
          <div
            class="fade-in max-w-xl mx-auto mt-8 bg-white/10 backdrop-blur-md border border-white/20 rounded-2xl p-6 shadow-lg mb-10"
          >
            <h3
              class="text-xl font-semibold mb-4 border-b border-black/20 pb-2 flex items-center gap-2 transition"
            >
              <svg
                t="1772247887851"
                class="icon"
                viewBox="0 0 1024 1024"
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
                p-id="2850"
                width="30"
                height="30"
              >
                <path
                  d="M523.52 809.28h114.86v-25.74c0-55.37 36.5-121.2 60.6-158.65 38.46-57.74 63.37-102.94 63.37-167.03 0-80.6-37.89-152.31-96.77-198.44-16.02-3.2-32.59-4.9-49.55-4.9-139.17 0-252 112.82-252 252 0 50.52 14.92 97.52 40.52 136.96l-0.01 0.03s0.08 0.11 0.21 0.28c3.81 5.86 7.86 11.54 12.13 17.05 20.02 29.41 58.21 91.49 67.1 148.44h39.54z"
                  fill="#E8CD97"
                  p-id="2851"
                ></path>
                <path
                  d="M668.45 842.36H361.72v-50.02c0-56.01-44.68-128.05-64.38-157.09-4.29-5.54-8.41-11.34-12.29-17.25l-10.14-13.52 0.98-1.46c-23.61-41.5-36.02-88.31-36.02-136.35 0-152.34 123.93-276.29 276.28-276.29s276.28 123.94 276.28 276.29c0 73.29-30.54 125.1-67.45 180.48-20.97 32.6-56.52 95.28-56.52 145.19v50.02z m-258.16-48.57h209.59v-1.45c0-59.21 35.05-126.11 64.46-171.79 40.39-60.63 59.51-98.99 59.51-153.88 0-125.57-102.15-227.72-227.71-227.72S288.43 341.1 288.43 466.67c0 43.77 12.49 86.28 36.14 123.02l0.65 1c3.44 5.29 7.12 10.46 10.95 15.39l0.9 1.24c27.35 40.17 73.22 117.63 73.22 185.02v1.45z"
                  fill="#472F17"
                  p-id="2852"
                ></path>
                <path
                  d="M335.96 468.04c-1.38-53.77 33.05-157.19 173.25-163.82l2.3 48.51c-128.3 6.06-127.11 109.66-127 114.06l-48.55 1.25zM668.71 960.47H361.95V793.79h306.76v166.68zM410.52 911.9h209.62v-69.54H410.52v69.54zM88.33 472.4h87.2v48.57h-87.2zM186.192 203.997l34.337-34.336 55.67 55.67-34.337 34.336zM491.86 64.22h48.57v75.18h-48.57zM856.76 469.68h87.2v48.57h-87.2zM756.073 222.603l55.67-55.67 34.336 34.337-55.67 55.67z"
                  fill="#472F17"
                  p-id="2853"
                ></path>
              </svg>
              简单介绍下我吧~
            </h3>

            <div class="space-y-3 text-sm md:text-base">
              <!-- 姓名 -->
              <div class="flex items-center gap-3">
                <span class="w-20 text-right">教育背景:</span>
                <span>浙江工业大学 计算机科学技术 本科</span>
              </div>
              <!-- 年龄 -->
              <div class="flex items-center gap-3">
                <span class="w-20 text-right">年龄:</span>
                <span>31岁</span>
              </div>
              <!-- 电话 -->
              <div class="flex items-center gap-3">
                <span class="w-20 text-right">电话:</span>
                <span>18667181848</span>
              </div>
              <!-- 邮箱 -->
              <div class="flex items-center gap-3">
                <span class="w-20 text-right">邮箱:</span>
                <span>452777439@qq.com</span>
              </div>
              <!-- 期望薪资 -->
              <div class="flex items-start gap-3">
                <span class="w-20 text-right">个人优势:</span>
                <span class="flex-1">
                  熟悉前端工程化开发，具备组件工程化、多环境管理、CSS
                  原子化等实践经验，可独立完成项目架构搭建。善于团队沟通，能独立解决问题，注重代码质量与用户体验，追求细节与极致效果。保持自主学习习惯，熟练使用
                  AI 辅助学习与代码审查，持续提升开发效率与技术能力。</span
                >
              </div>
            </div>
          </div>
          <!-- <div class="flex gap-4">
            <a
              href="#contact"
              class="border border-[#3b82f6] text-[#3b82f6] px-6 py-3 rounded-lg hover:bg-[#3b82f6]/10 transition"
            >
              联系我
            </a>
            <a
              href="https://github.com/你的账号"
              target="_blank"
              class="border border-[#3b82f6] text-[#3b82f6] px-6 py-3 rounded-lg hover:bg-[#3b82f6]/10 transition"
            >
              GitHub
            </a>
          </div> -->
        </div>
        <div class="md:w-1/2 fade-in">
          <div
            class="relative w-64 h-94 mx-auto flex items-center justify-center"
          >
            <!-- 紫色背景：和父容器同尺寸、同圆角 -->
            <div
              class="absolute inset-0 bg-gradient-to-r from-[#3b82f6] to-[#8b5cf6] rounded-full blur-lg opacity-50"
            ></div>
            <!-- 头像：垂直居中，且尺寸适配父容器 -->
            <img
              src="./assets/my.png"
              alt="头像"
              class="relative w-64 rounded-full object-cover border-4 border-white dark:border-[#1e293b] shadow-xl card-3d"
            />
          </div>
        </div>
      </div>
    </section>

    <!-- 技能区域 -->
    <section id="skills" class="section bg-gray-50 dark:bg-[#1e293b]/50">
      <div class="container">
        <h2 class="text-3xl font-bold text-center mb-12 fade-in">我的技能</h2>
        <div class="flex flex-col md:flex-row gap-8">
          <div class="md:w-1/2 fade-in h-80">
            <div id="skills-chart" class="w-full h-full"></div>
          </div>
          <div class="md:w-1/2 fade-in">
            <div class="grid grid-cols-1 sm:grid-cols-2 gap-4">
              <div
                class="p-4 border rounded-lg hover:border-[#3b82f6] transition card-3d"
              >
                <h3 class="font-bold mb-2">前端基础</h3>
                <p>HTML5/CSS3、Flex、响应式、Tailwind、less</p>
              </div>
              <div
                class="p-4 border rounded-lg hover:border-[#3b82f6] transition card-3d"
              >
                <h3 class="font-bold mb-2">编程语言</h3>
                <p>JavaScript、Node</p>
              </div>
              <div
                class="p-4 border rounded-lg hover:border-[#3b82f6] transition card-3d"
              >
                <h3 class="font-bold mb-2">框架生态</h3>
                <p>Vue2、Element UI 、Lodash、Echarts、swiper、uniapp</p>
              </div>
              <div
                class="p-4 border rounded-lg hover:border-[#3b82f6] transition card-3d"
              >
                <h3 class="font-bold mb-2">工程化</h3>
                <p>Gitee、组件封装、函数封装、CSS原子化</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- 工作经历 -->
    <section id="experience" class="section">
      <div class="container">
        <h2 class="text-3xl font-bold text-center mb-12 fade-in">工作经历</h2>
        <div class="space-y-8">
          <div class="flex flex-col md:flex-row gap-4 fade-in">
            <div class="md:w-1/4 font-bold">2023.12 - 2025.9</div>
            <div
              class="md:w-3/4 p-4 border-l-4 border-[#3b82f6] rounded-r-lg bg-gray-50 dark:bg-[#1e293b]/50"
            >
              <h3 class="text-xl font-bold">
                浙江省国家电网 | 可视化开发工程师
              </h3>
              <p class="mt-2 text-[#9ca3af] dark:text-[#9ca3af]">
                1.负责浙江省各个市级的新一代系统(Linux,window双系统)
                前端部分的开发，包括技术选型,项目构建,页面设计,原始数据处理,负责首页,潮流图,供区图,geo图等多页面开发,均由个人独立开发
              </p>
              <p class="mt-2 text-[#9ca3af] dark:text-[#9ca3af]">
                2.项目主要以可视化为主,大量图表的数据处理,对数据动画的渲染优化,减少大量动画导致的页面卡顿
              </p>
              <p class="mt-2 text-[#9ca3af] dark:text-[#9ca3af]">
                3.对一些复杂原始数据进行处理，通过算法以及各个表格的数据统一处理判断出电流的各个流向,是否过载等等,实现多表格数据统一
              </p>
              <p class="mt-2 text-[#9ca3af] dark:text-[#9ca3af]">
                4.对于一些txt文件解析,提取复杂数据
              </p>
              <p class="mt-2 text-[#9ca3af] dark:text-[#9ca3af]">
                5.对函数,样式封装,有利于后期项目的维护,日常也会对代码结构优化
              </p>
            </div>
          </div>
          <div class="flex flex-col md:flex-row gap-4 fade-in">
            <div class="md:w-1/4 font-bold">2023.06 - 2023.11</div>
            <div
              class="md:w-3/4 p-4 border-l-4 border-[#8b5cf6] rounded-r-lg bg-gray-50 dark:bg-[#1e293b]/50"
            >
              <h3 class="text-xl font-bold">
                杭州央选信息服务有限公司 | 前端开发工程师
              </h3>
              <p class="mt-2 text-[#9ca3af] dark:text-[#9ca3af]">
                1.该项目致力于在创作者流量时代,基于
                SaaS、数据、策划和运营服务,成为品牌的内容电商综合服 务平台。
              </p>
              <p class="mt-2 text-[#9ca3af] dark:text-[#9ca3af]">
                2.本人主要负责项目的达人,CRM,团队管理模块,负责日常迭代，线上 bug
                处理,组件的封装，项目的视觉优化
              </p>
              <p class="mt-2 text-[#9ca3af] dark:text-[#9ca3af]">
                3.个人独立负责官网的开发https://www.yangxuan.net
              </p>
              <p class="mt-2 text-[#9ca3af] dark:text-[#9ca3af]">
                4.参与小程序的维护
              </p>
            </div>
          </div>
          <div class="flex flex-col md:flex-row gap-4 fade-in">
            <div class="md:w-1/4 font-bold">2022.9-2023.4</div>
            <div
              class="md:w-3/4 p-4 border-l-4 border-[#0d9488] rounded-r-lg bg-gray-50 dark:bg-[#1e293b]/50"
            >
              <h3 class="text-xl font-bold">
                杭州店飞科技有限公司 | 前端开发工程师
              </h3>
              <p class="mt-2 text-[#9ca3af] dark:text-[#9ca3af]">
                1.初创公司,官网设计与开发,http://www.shopflyer-df.com
              </p>
              <p class="mt-2 text-[#9ca3af] dark:text-[#9ca3af]">
                2.金牛（海外跨境
                Saas）项目搭建独立从0到1,完成了包括授权管理,数据看栏,用户开户以及账户充值支付的功能开发
              </p>
              <p class="mt-2 text-[#9ca3af] dark:text-[#9ca3af]">
                3.日常项目的维护
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- 项目经验 -->
    <!-- <section id="projects" class="section bg-gray-50 dark:bg-[#1e293b]/50">
      <div class="container">
        <h2 class="text-3xl font-bold text-center mb-12 fade-in">项目经验</h2>
        <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          <div
            class="bg-white dark:bg-[#1e293b] rounded-lg shadow-md overflow-hidden fade-in card-3d"
          >
            <img
              src="https://picsum.photos/600/400?1"
              alt="电商平台"
              class="w-full h-48 object-cover"
            />
            <div class="p-6">
              <h3 class="text-xl font-bold mb-2">电商平台</h3>
              <p class="text-[#9ca3af] dark:text-[#9ca3af] mb-4">
                基于Vue2+Element
                UI开发的全端电商平台，包含商品、购物车、订单等核心模块。
              </p>
              <div class="flex flex-wrap gap-2 mb-4">
                <span
                  class="px-2 py-1 bg-[#3b82f6]/10 text-[#3b82f6] rounded text-sm"
                  >Vue2</span
                >
                <span
                  class="px-2 py-1 bg-[#3b82f6]/10 text-[#3b82f6] rounded text-sm"
                  >Vuex</span
                >
                <span
                  class="px-2 py-1 bg-[#3b82f6]/10 text-[#3b82f6] rounded text-sm"
                  >Element UI</span
                >
              </div>
              <a
                href="https://github.com/你的项目"
                target="_blank"
                class="text-[#3b82f6] hover:underline"
              >
                查看源码 →
              </a>
            </div>
          </div>
          <div
            class="bg-white dark:bg-[#1e293b] rounded-lg shadow-md overflow-hidden fade-in card-3d"
          >
            <img
              src="https://picsum.photos/600/400?2"
              alt="管理系统"
              class="w-full h-48 object-cover"
            />
            <div class="p-6">
              <h3 class="text-xl font-bold mb-2">后台管理系统</h3>
              <p class="text-[#9ca3af] dark:text-[#9ca3af] mb-4">
                Vue2+Vue
                Router开发的企业管理系统，支持权限控制、数据可视化、批量操作。
              </p>
              <div class="flex flex-wrap gap-2 mb-4">
                <span
                  class="px-2 py-1 bg-[#8b5cf6]/10 text-[#8b5cf6] rounded text-sm"
                  >Vue2</span
                >
                <span
                  class="px-2 py-1 bg-[#8b5cf6]/10 text-[#8b5cf6] rounded text-sm"
                  >ECharts</span
                >
                <span
                  class="px-2 py-1 bg-[#8b5cf6]/10 text-[#8b5cf6] rounded text-sm"
                  >Axios</span
                >
              </div>
              <a
                href="https://github.com/你的项目"
                target="_blank"
                class="text-[#3b82f6] hover:underline"
              >
                查看源码 →
              </a>
            </div>
          </div>
          <div
            class="bg-white dark:bg-[#1e293b] rounded-lg shadow-md overflow-hidden fade-in card-3d"
          >
            <img
              src="https://picsum.photos/600/400?3"
              alt="个人博客"
              class="w-full h-48 object-cover"
            />
            <div class="p-6">
              <h3 class="text-xl font-bold mb-2">个人博客</h3>
              <p class="text-[#9ca3af] dark:text-[#9ca3af] mb-4">
                Vue2+VuePress开发的静态博客，支持Markdown编辑、暗黑模式、文章搜索。
              </p>
              <div class="flex flex-wrap gap-2 mb-4">
                <span
                  class="px-2 py-1 bg-[#3b82f6]/10 text-[#3b82f6] rounded text-sm"
                  >Vue2</span
                >
                <span
                  class="px-2 py-1 bg-[#3b82f6]/10 text-[#3b82f6] rounded text-sm"
                  >Markdown</span
                >
                <span
                  class="px-2 py-1 bg-[#3b82f6]/10 text-[#3b82f6] rounded text-sm"
                  >静态部署</span
                >
              </div>
              <a
                href="https://github.com/你的项目"
                target="_blank"
                class="text-[#3b82f6] hover:underline"
              >
                查看源码 →
              </a>
            </div>
          </div>
        </div>
      </div>
    </section> -->

    <!-- 联系我 -->
    <section id="contact" class="section pb-24">
      <div class="container text-center fade-in">
        <h2 class="text-3xl font-bold mb-6">联系方式</h2>
        <p class="text-[#9ca3af] dark:text-[#9ca3af] mb-8">
          如果你觉得我的简历还不错，欢迎随时联系我～ 谢谢！
        </p>
        <div class="flex flex-col sm:flex-row justify-center gap-4">
          <a
            href="tel:18667181848"
            class="flex items-center justify-center gap-2 px-6 py-3 border rounded-lg hover:border-[#3b82f6] transition"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              class="h-5 w-5"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z"
              />
            </svg>
            18667181848
          </a>
          <a
            href="mailto:452777439@qq.com"
            class="flex items-center justify-center gap-2 px-6 py-3 border rounded-lg hover:border-[#3b82f6] transition"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              class="h-5 w-5"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"
              />
            </svg>
            452777439@qq.com
          </a>
          <!-- <a
            href="https://github.com/你的账号"
            target="_blank"
            class="flex items-center justify-center gap-2 px-6 py-3 border rounded-lg hover:border-[#3b82f6] transition"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              class="h-5 w-5"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M10 20l4-16m4 4l4 4-4 4M6 16l-4-4 4-4"
              />
            </svg>
            GitHub
          </a> -->
        </div>
      </div>
    </section>

    <!-- 页脚 -->
    <footer class="bg-[#1e293b] text-white py-8">
      <div class="container text-center">
        <p>© 2026 倪国晓 的个人简历</p>
      </div>
    </footer>
  </div>
</template>

<script>
// 这里保持你之前的 script 内容不变
import * as echarts from 'echarts'

export default {
  name: 'App',
  data() {
    return {
      isDark: false,
    }
  },
  mounted() {
    const darkMode = localStorage.getItem('darkMode')
    if (darkMode === 'true') {
      this.isDark = true
      document.documentElement.classList.add('dark')
    }

    const fadeElements = document.querySelectorAll('.fade-in')
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('active')
          }
        })
      },
      { threshold: 0.1 },
    )

    fadeElements.forEach((el) => observer.observe(el))

    const chartDom = document.getElementById('skills-chart')
    const myChart = echarts.init(chartDom)
    const option = {
      title: { text: '技能熟练度' },
      tooltip: { trigger: 'item' },
      radar: {
        shape: 'polygon', // 雷达图形状：polygon（多边形）或 circle（圆形）
        splitNumber: 5, // 雷达图的刻度数量，默认5层
        indicator: [
          { name: 'HTML/CSS', max: 100 },
          { name: 'JavaScript', max: 100 },
          { name: 'Vue2', max: 100 },
          { name: '工程化', max: 100 },
          { name: '兼容性', max: 100 },
        ],
      },
      series: [
        {
          name: '技能评分',
          type: 'radar', // 新增：明确指定这是雷达图系列
          data: [
            {
              value: [80, 85, 80, 80, 70],
              name: '我的技能',
              areaStyle: {
                color: 'rgba(139, 92, 255, 0.3)', // 紫色半透明填充
              },
              lineStyle: {
                color: '#8b5cf6', // 紫色边框
                width: 2,
              },
              itemStyle: {
                color: '#8b5cf6', // 数据点颜色
              },
            },
          ],
        },
      ],
      backgroundColor: 'transparent',
    }
    myChart.setOption(option)

    window.addEventListener('resize', () => {
      myChart.resize()
    })
  },
  methods: {
    toggleDarkMode() {
      this.isDark = !this.isDark
      if (this.isDark) {
        document.documentElement.classList.add('dark')
        localStorage.setItem('darkMode', 'true')
      } else {
        document.documentElement.classList.remove('dark')
        localStorage.setItem('darkMode', 'false')
      }
    },
  },
}
</script>
